import styled from "styled-components";
import { types } from "../BehaviourAnalysis/BehaviourAnalysis";

const getTypeColor = (ResultType: types) => {
    switch (ResultType) {
        case types.tryghed:
            return "#87A8C1";
        case types.struktur:
            return "#D59588";
        case types.relation:
            return "#CCAC60";
        case types.balance:
            return "#A598C4";
        case types.fremdrift:
            return "#95B88C";
    }
};

const getTypeBackgroundColor = (ResultType: types) => {
    switch (ResultType) {
        case types.tryghed:
            return "#B0C5D8";
        case types.struktur:
            return "#E7BDB3";
        case types.relation:
            return "#DEC894";
        case types.balance:
            return "#C5BDD9";
        case types.fremdrift:
            return "#BCD4B6";
    }
};

export const TopBanner = styled.div`
   margin-top: 28px;
`;

export const TypeImgContainer = styled.div`
display: block;
width: 50%;
height: auto;
object-fit: contain;
margin-left: auto;
margin-right: auto;
margin-bottom: 16px;
    @media (min-width: 768px) {
        width: 100%;
    }
`;

export const TypeImg = styled.img`
`;

export const TypeTitle = styled.h1`
    display: block;
    margin-bottom: 16px;
    font-weight: 500;
`;


export const Type = styled.span<{ ResultType: types | undefined }>`
   color: ${({ ResultType }) => ResultType ? getTypeColor(ResultType) : "inherit"};
font-weight: 600;
`;

export const ResultText = styled.p`
    font-size: 16px;
    padding: 5px;
`;

export const SituationBg = styled.div`
    background-color: #FBF1EA;
    padding: 20px 0px;
     margin-top: 20px;
`;


export const ResultContainerTop = styled.div`
    margin: 0px 20px;
    @media (min-width: 768px) {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        margin: 0px 50px;
    }
    @media (min-width: 1024px) {
        max-width: 900px;
        margin-left: auto;
        margin-right: auto;
    }
`;
    
export const ResultContainer = styled.div`
    margin: 0px 20px;
    @media (min-width: 768px) {
        margin: 0px 50px;
    }
    @media (min-width: 1024px) {
        max-width: 900px;
        margin-left: auto;
        margin-right: auto;
    }
`;

export const SituationTitle = styled.p`
    font-size: 1.75rem;
    margin-bottom: 8px;
`;

export const SituationText = styled.p`
    margin-bottom: 4px;
`;
    
export const Situation = styled.div<{ ResultType: types | undefined }>`
    background-color: ${({ ResultType }) => ResultType ? getTypeBackgroundColor(ResultType) : "#fff"};
    border-radius: 14px;
    padding: 24px;
    ul {
    list-style-type: disc;
    }
`;

export const LeadContainer = styled.div`
    @media (min-width: 768px) {
        margin: 0px 50px;
    }
    @media (min-width: 1024px) {
        max-width: 900px;
        margin-left: auto;
        margin-right: auto;
    } 
`;
